import Badge from './Badge.container';

export default Badge;
